<template>
    <b-form-group :label="label" :label-for="inputId" :class="formGroupClass">
        <v-select
            :filterable="false"
            :inputId="inputId"
            :placeholder="placeholder"
            :reduce="option => option[valueKey]"
            :options="options"
            :multiple="multiple"
            :class="valid === false ? 'border-danger-for-v-select' : ''"
            :label="labelKey"
            v-model="vModel"
            :clearable="this.clearable"
            :loading="loading"
            :state="valid"
            @input="saveSelectedOption"
            @open="onOpen"
            @close="onClose"
            @search="onSearch"
        >
            <template #list-footer>
                <div v-show="hasNextPage" ref="load" class="loader">
                    {{ loadMoreText }}
                </div>
            </template>
            <template #option="option">
                <slot name="option" :data="option">
                    <div v-if="bindLabel.length > 1" class="">
                        {{ option[bindLabel[0]][bindLabel[1]] }}
                    </div>
                    <div v-else class="">{{ option[bindLabel] }}</div>
                </slot>
            </template>
            <template #selected-option="option">
                <div v-if="bindLabel.length > 1" class="">
                    {{ option[bindLabel[0]][bindLabel[1]] }}
                </div>
                <div v-else class="">{{ option[bindLabel] }}</div>
            </template>
        </v-select>
        <small class="text-danger">{{ errorMessage }}</small>
    </b-form-group>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'Ssr-select',
    props: {
        label: {type: String, default: 'Select'},
        placeholder: {type: String, default: 'Select'},
        inputId: {type: String, default: 'select'},
        formGroupClass: {type: String, default: ''},
        value: {required: true},
        endpoint: {type: String, required: true},
        clearable: {type: Boolean, required: false, default: true},
        limit: {type: Number, default: 20},
        multiple: {type: Boolean, required: false, default: false},
        labelKey: {type: String, default: 'label'},
        valueKey: {type: String, default: 'id'},
        valid: {default: null},
        errorMessage: {type: String, default: ''},
        loadMoreText: {type: String, default: 'Loading more options'}
    },
    computed: {
        vModel: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        hasNextPage() {
            return this.options.length < this.total
        },
        objectToQueryString() {
            const keyValuePairs = [];
            for (const key in this.params) {
                if (this.params.hasOwnProperty(key) && this.params[key]) {
                    const value = encodeURIComponent(this.params[key]);
                    keyValuePairs.push(`${key}=${value}`);
                }
            }

            return keyValuePairs.join('&');
        }
    },
    data() {
        return {
            options: [],
            total: 0,
            bindLabel: 'label',
            loading: true,
            params: {
                page: 1,
                per_page: 10,
                'sort_keys[]': undefined,
                'sort_dir[]': undefined,
                search: undefined
            },
            observer: null,
            selected: null
        }
    },
    methods: {
        onSearch(search) {
            if (!this.selected || search != '') {
                this.loading = true
                this.search(search, this)
            }
        },
        search: _.debounce((search, vm) => {
            vm.params.page = 1
            vm.params.search = search
            vm.$nextTick(() => {
                if (vm.selected) {
                    vm.options = [vm.selected]
                } else {
                    vm.options = []
                }
            })
            vm.getData(true)
        }, 500),
        async onOpen() {
            this.params.search = undefined
            if (this.options.length < 20) {
                await this.getData()
            }
            if (this.hasNextPage) {
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
            }
        },
        onClose() {
            this.observer.disconnect()
            // this.params.page = 1
        },
        async infiniteScroll([{isIntersecting, target}]) {
            if (isIntersecting) {
                const ul = target.offsetParent
                const scrollTop = target.offsetParent.scrollTop
                this.params.page++
                await this.getData()
                ul.scrollTop = scrollTop
            }
        },
        getData(fromSearch = false) {
            return $.ajax({
                method: "GET",
                url: this.endpoint + '?' + this.objectToQueryString,
            })
                .then(res => {
                    // check if exist then skip this item

                    if (res.data) {
                        res.data.data.forEach(item => {
                            if (!this.options.some(obj => obj.id === item.id)) {
                                this.options.push(item)
                            }
                        })
                    }
                    this.total = res['recordsFiltered'] || res['total']
                })
                .always(() => {
                    this.loading = false
                    if (fromSearch && this.hasNextPage) {
                        setTimeout(() => {
                            this.observer.observe(this.$refs.load)
                        }, 100)
                    }
                })
        },
        saveSelectedOption(id) {
            if (!id) {
                this.selected = null
                this.params.page = 1
                this.params.search = undefined
                this.options = []
                this.getData()
            } else {
                this.selected = this.options.filter(option => option.id === id).pop()
            }
        }
    },
    mounted() {
        this.observer = new IntersectionObserver(this.infiniteScroll)
        this.bindLabel = this.labelKey.split('.')
        this.params["sort_dir[]"] = 'asc'
        this.params["sort_keys[]"] = 'id'
        this.params.per_page = this.limit
        this.getData()
    }
}
</script>

<style scoped>
.loader {
    text-align: center;
}
</style>
